module.exports = __webpack_public_path__ + "img/Asymmetry.65651ca4.png";